import { useEffect, useState } from 'react';

export const useFetchEnums = (url, { dispatchAPI, message }) => {
  const [isFieldsLoading, setIsFieldsLoading] = useState(true);
  const [enums, setEnums] = useState({});

  useEffect(() => {
    let isMounted = true;

    const fetchEnums = async () => {
      try {
        setIsFieldsLoading(true);

        const { data } = await dispatchAPI('GET', { url });

        if (isMounted) {
          setEnums(data);
        }
      } catch (e) {
        if (e.response && isMounted) {
          message(e.response.status);
        }
      } finally {
        if (isMounted) {
          setIsFieldsLoading(false);
        }
      }
    };

    fetchEnums();

    return () => {
      isMounted = false;
    };
  }, [url]);

  return { enums, isFieldsLoading };
};
